module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/h1-title-12ce97cba9e809040d4883c8213e4782.png";